import identityStyles from '../../../sass/heroidentity.module.scss';
export default (function (_ref) {
  var appId = _ref.appId,
    redirectUrl = _ref.redirectUrl,
    _ref$loginUrl = _ref.loginUrl,
    loginUrl = _ref$loginUrl === void 0 ? 'https://account.collegeboard.org/login/login' : _ref$loginUrl,
    _ref$createAccountUrl = _ref.createAccountUrl,
    createAccountUrl = _ref$createAccountUrl === void 0 ? 'https://account.collegeboard.org/login/signUp' : _ref$createAccountUrl,
    _ref$studentLogin = _ref.studentLogin,
    studentLogin = _ref$studentLogin === void 0 ? false : _ref$studentLogin,
    _ref$studentBtnText = _ref.studentBtnText,
    studentBtnText = _ref$studentBtnText === void 0 ? 'Student' : _ref$studentBtnText,
    _ref$professionalLogi = _ref.professionalLogin,
    professionalLogin = _ref$professionalLogi === void 0 ? true : _ref$professionalLogi,
    _ref$professionalBtnT = _ref.professionalBtnText,
    professionalBtnText = _ref$professionalBtnT === void 0 ? 'Educator' : _ref$professionalBtnT,
    _ref$heroBackgroundIm = _ref.heroBackgroundImageUrl,
    heroBackgroundImageUrl = _ref$heroBackgroundIm === void 0 ? '' : _ref$heroBackgroundIm,
    _ref$heroContentText = _ref.heroContentText,
    heroContentText = _ref$heroContentText === void 0 ? '' : _ref$heroContentText,
    _ref$identityDesc = _ref.identityDesc,
    identityDesc = _ref$identityDesc === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, "Which type of account do you", /*#__PURE__*/React.createElement("br", null), "want to ", /*#__PURE__*/React.createElement("strong", null, "sign in"), " to?") : _ref$identityDesc;
  return /*#__PURE__*/React.createElement("div", {
    id: "cb-atlas-identity-2",
    "data-cbtrack-widget": "identity",
    className: "".concat(identityStyles['cb-widget'], " ").concat(identityStyles.root, " cb-apricot3")
  }, /*#__PURE__*/React.createElement("div", {
    className: identityStyles.background
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-lg-5 col-lg-offset-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: identityStyles.hero
  }, /*#__PURE__*/React.createElement("img", {
    className: "transition ",
    src: heroBackgroundImageUrl,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: identityStyles.content
  }, heroContentText ? /*#__PURE__*/React.createElement("h2", null, heroContentText) : null))), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-offset-1 col-md-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: identityStyles['cb-wg-identity-card']
  }, /*#__PURE__*/React.createElement("div", {
    className: identityStyles['cb-wg-identity-card-container']
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-roboto-slab-bold"
  }, "Sign In"), /*#__PURE__*/React.createElement("p", {
    className: identityStyles['cb-wg-margin-top-8']
  }, identityDesc), studentLogin ? /*#__PURE__*/React.createElement("div", {
    className: identityStyles['login-flow-button']
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(loginUrl, "?appId=").concat(appId, "&idp=ECL&DURL=").concat(redirectUrl),
    className: "btn btn-sm btn-primary ".concat(identityStyles['cb-wg-margin-top-16'])
  }, studentBtnText)) : null, professionalLogin ? /*#__PURE__*/React.createElement("div", {
    className: identityStyles['login-flow-button']
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(loginUrl, "?appId=").concat(appId, "&idp=EPL&skipEnroll=Y&DURL=").concat(redirectUrl),
    className: "btn btn-sm btn-primary ".concat(identityStyles['cb-wg-margin-top-16'])
  }, professionalBtnText)) : null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(identityStyles['cb-wg-margin-top-32'], " ").concat(identityStyles['cb-wg-padding-top-16'], " ").concat(identityStyles['cb-wg-border-top-dashed-1'])
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-margin-top-8"
  }, "Don't have an account?"), /*#__PURE__*/React.createElement("a", {
    href: "".concat(createAccountUrl, "?appId=").concat(appId, "&DURL=").concat(redirectUrl),
    className: identityStyles['cb-wg-link-black']
  }, "Create Account")))))))));
});